export default function request(type, path, method, payload, query, sort, isCache) {
  return async (dispatch) => {
    const hasBody = method !== 'GET';

    const queryString = query && query.map((param) => `"${Object.keys(param)[0]}":${Object.values(param)[0]}`);

    let suffix = path;

    if (!hasBody) {
      if (!isCache) {
        suffix += '?t=' + Date.now();
      } else {
        suffix += '?';
      }
    }

    if (query && queryString.length) {
      suffix = `${suffix}&where={${queryString}}`;
    }

    if (sort && sort.length) {
      suffix = suffix + '&sort=' + sort;
    }

    const url = `${import.meta.env.VITE_API_SERVER}${suffix}`;
    const body = hasBody ? JSON.stringify(payload) : undefined;

    dispatch({
      type,
      url,
      payload,
      query,
      isLoading: true,
    });

    return window
      .fetch(url, {
        method,
        body,
        mode: 'cors',
        cache: 'default',
        redirect: 'follow',
      })
      .then(({ response, body }) => {
        return dispatch({
          type,
          body,
          payload,
          query,
          url: response.url,
          status: response.status,
          headers: response.headers,
          ok: response.ok,
          isLoading: false,
        });
      })
      .catch((error) => {
        return dispatch({
          type,
          error,
          url,
          payload,
          query,
          failed: true,
          isLoading: false,
        });
      });
  };
}
